module.exports={
  "test": {
    "question": [
      {
        "id": "1",
        "text": "Как выглядел герой Кевина <br/> Спейси в фильме \"9 жизней\"?",
        "answers": [
          {
            "id": "1",
            "img": "/img/content/answer-1-1.png"
          },
          {
            "id": "2",
            "img": "/img/content/answer-1-2.png"
          },
          {
            "id": "3",
            "img": "/img/content/answer-1-3.png"
          }
        ],
        "correctId": "2",
        "afterText": {
          "correct": "Одно лицо!",
          "incorrect": "Сходство есть, но мимо!"
        }

      },
      {
        "id": "2",
        "text": "Кто помог мышонку <br/> справиться с неприятностями?",
        "answers": [
          {
            "id": "1",
            "img": "/img/content/answer-2-1.png"
          },
          {
            "id": "2",
            "img": "/img/content/answer-2-2.png"
          },
          {
            "id": "3",
            "img": "/img/content/answer-2-3.png"
          }
        ],
        "correctId": "1",
        "afterText": {
          "correct": "Отлично!",
          "incorrect": "От такого помощи не дождёшься"
        }

      },
      {
        "id": "3",
        "text": "Что напугало Доктора Дулиттла?",
        "answers": [
          {
            "id": "1",
            "img": "/img/content/answer-3-1.png"
          },
          {
            "id": "2",
            "img": "/img/content/answer-3-2.png"
          },
          {
            "id": "3",
            "img": "/img/content/answer-3-3.png"
          }
        ],
        "correctId": "3",
        "afterText": {
          "correct": "А вроде такая мелочь",
          "incorrect": "Такое бы кого угодно напугало!"
        }

      },
      {
        "id": "4",
        "text": "Кто на этой картинке <br/> Гермионин Косолапсус?",
        "answers": [
          {
            "id": "1",
            "img": "/img/content/answer-4-1.png"
          },
          {
            "id": "2",
            "img": "/img/content/answer-4-2.png"
          },
          {
            "id": "3",
            "img": "/img/content/answer-4-3.png"
          }
        ],
        "correctId": "2",
        "afterText": {
          "correct": "Косолапсус найден!",
          "incorrect": "Ему бы подошла эта кличка"
        }

      }
    ]
  }
}